import { useQuery } from '@hooks/reactQuery';

import { getCountries } from '@api/common';

import { countriesFormatted } from '@utils/formatter';

import { ICountry } from '@interfaces/organisation/organisations';

import { refetchOptions } from '@constants/common';
import { COUNTRIES } from '@constants/queryKeys';

export const useQueryCountries = () => {
	const {
		data: countries,
		isLoading: isLoadingCountries,
		isFetching: isFetchingCountries,
	} = useQuery<Array<ICountry>>({
			queryKey: [COUNTRIES],
			queryFn: getCountries,
			select: (countries: Array<ICountry>) => countriesFormatted(countries),
			...refetchOptions,
		},
	);

	return {
		countries: countries || [],
		isLoadingCountries: isLoadingCountries || isFetchingCountries,
	};
};
